import Vue from 'vue'
import Router from 'vue-router'
import Cookie from 'js-cookie'
import Login from '@/pages/Login';
import Home from '@/pages/Home';
import index from '@/pages/index';
import user from '@/pages/user';
import customer from '@/pages/customer';
import orderList from '@/pages/orderList';
import birthday from '@/pages/birthday';
import informationList from '@/pages/informationList';
Vue.use(Router)

var router= new Router({
  routes: [
    //重定向
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/home',
      component: Home,
      children: [
        {
          path: '/index',
          component: index,
          name:'首页'
        },
        {
          path: '/user',
          component: user,
          name:'用户管理'
        },
        {
          path: '/customer',
          component: customer,
          name:'客户管理'
        },
        {
          path: '/orderList',
          component: orderList,
          name:'贷款单列表'
        },
        {
          path: '/birthday',
          component: birthday,
          name:'生日提醒'
        },
        {
          path: '/informationList',
          component: informationList,
          name:'放款信息列表'
        },
      ]
    },

  ]
})
router.beforeEach((to,form,next)=>{
   if(Cookie.get('token')){
    // router.app.$options.store.commit('updateName',to.name)
     next()
   }else {
     if (to.path!='/login'){
       next({
         path:'/login'
       })
     } else {
      
       next()
     }
   }
  // next()
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js